/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataLeak } from './DataLeak';
import {
    DataLeakFromJSON,
    DataLeakFromJSONTyped,
    DataLeakToJSON,
    DataLeakToJSONTyped,
} from './DataLeak';

/**
 * 
 * @export
 * @interface PaginatedDataLeakList
 */
export interface PaginatedDataLeakList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDataLeakList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataLeakList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataLeakList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DataLeak>}
     * @memberof PaginatedDataLeakList
     */
    results: Array<DataLeak>;
}

/**
 * Check if a given object implements the PaginatedDataLeakList interface.
 */
export function instanceOfPaginatedDataLeakList(value: object): value is PaginatedDataLeakList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDataLeakListFromJSON(json: any): PaginatedDataLeakList {
    return PaginatedDataLeakListFromJSONTyped(json, false);
}

export function PaginatedDataLeakListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDataLeakList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(DataLeakFromJSON)),
    };
}

  export function PaginatedDataLeakListToJSON(json: any): PaginatedDataLeakList {
      return PaginatedDataLeakListToJSONTyped(json, false);
  }

  export function PaginatedDataLeakListToJSONTyped(value?: PaginatedDataLeakList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DataLeakToJSON)),
    };
}

